import { z } from 'zod';
import { PAGINATION_DEFAULT_LIMIT, PAGINATION_MAX_LIMIT } from '../constants/pagination.js';

export const PaginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce
    .number()
    .int()
    .min(1)
    .max(PAGINATION_MAX_LIMIT)
    .default(PAGINATION_DEFAULT_LIMIT)
    .optional(),
});

export type PaginationQuery = z.infer<typeof PaginationQuerySchema>;

export function makePaginatedResponse<T>(items: T[], nextCursor?: string) {
  return {
    items,
    ...(nextCursor ? { nextCursor } : {}),
  };
}

export type PaginatedResponse<T> = {
  items: T[];
  nextCursor?: string;
};
